import { instance } from "api/apiBase";
import {
  BoomFiLender,
  BoomFiMagicLinkResponse,
  BoomFiStatusResponse
} from "api/boom-finance/types";

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/boom_fi";

export const boomFiApi = {
  connect: async (): Promise<BoomFiStatusResponse> => {
    const { data } =
      await instance.post<BoomFiStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  // Implement in BoomFinance API
  disconnect: async (): Promise<BoomFiStatusResponse> => {
    const { data } =
      await instance.delete<BoomFiStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  getLenders: async (): Promise<BoomFiLender[]> => {
    const { data } = await instance.get<{ data: BoomFiLender[] }>(
      `${BASE_ENDPOINT_URL}/lenders`
    );
    return data.data;
  },

  setLenderEnablement: async ({
    lenderId,
    enabled
  }: {
    lenderId: string;
    enabled: boolean;
  }): Promise<BoomFiLender> => {
    const { data } = await instance.patch<BoomFiLender>(
      `${BASE_ENDPOINT_URL}/lenders/${lenderId}/enablement`,
      { enabled }
    );
    return data;
  },

  createMagicLink: async (): Promise<BoomFiMagicLinkResponse> => {
    const { data } = await instance.post<BoomFiMagicLinkResponse>(
      `${BASE_ENDPOINT_URL}/magic_link`
    );
    return data;
  }
};
